import React from "react";
import GoBack from "shared/ui/GoBack";
import InviteContent from "widgets/InviteContent";

const Invite: React.FC = () => {
  return (
    <main>
      <GoBack black />
      <InviteContent />
    </main>
  );
};

export default Invite;
